import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/icon-map.png'
import _imports_1 from '../assets/images/icon-phone.png'
import _imports_2 from '../assets/images/icon-email.png'
import _imports_3 from '../assets/images/icon-website.png'
import _imports_4 from '../assets/images/icon-facebook.png'
import _imports_5 from '../assets/images/icon-instagram.png'
import _imports_6 from '../assets/images/icon-whatsapp.png'


const _withScopeId = n => (_pushScopeId("data-v-31fd5bca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "infos" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "info"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "address"
}, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "info"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "phone"
}, null, -1))
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 2,
  class: "info"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "e-mail"
}, null, -1))
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 3,
  class: "info"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "website"
}, null, -1))
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "social" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "facebook"
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "instagram"
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 2 }
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "whatsapp"
}, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "img" }
const _hoisted_29 = ["src"]

import { onBeforeMount, reactive, ref } from "vue";
import { getPost } from "@/services/portalService";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'PostView',
  setup(__props) {

const route = useRoute();
const post = reactive({
  hid: "",
  name: "",
  image: "",
  description: "",
  slug: "",
  phone: "",
  instagram: "",
  facebook: "",
  webSite: "",
  email: "",
  whatsApp: "",
  workHours: "",
  tags: "",
  categoryHid: "",
  addressHid: "",
  street: "",
  street2: "",
  city: "",
  state: "",
  country: "",
  zipCode: "",
  lat: "",
  lng: "",
  lastModified: "",
  lastModifiedBy: "",
  lastModifiedAtLocal: "",
  address: "",
});

const fetchPost = async () => {
  const p = await getPost(route.params.post.toString());
  post.hid = p.hid;
  post.name = p.name;
  post.image = p.image;
  post.description = p.description;
  post.slug = p.slug;
  post.phone = p.phone;
  post.instagram = p.instagram;
  post.facebook = p.facebook;
  post.webSite = p.webSite;
  post.email = p.email;
  post.workHours = p.workHours;
  post.tags = p.tags;
  post.categoryHid = p.categoryHid;
  post.addressHid = p.addressHid;
  post.street = p.street;
  post.street2 = p.street2;
  post.city = p.city;
  post.state = p.state;
  post.country = p.country;
  post.zipCode = p.zipCode;
  post.lat = p.lat;
  post.lng = p.lng;
  post.lastModified = p.lastModified;
  post.lastModifiedBy = p.lastModifiedBy;
  post.lastModifiedAtLocal = p.lastModifiedAtLocal;
  post.address = post.street ? `${post.street}, ` : "";
  post.address += post.street2 ? `${post.street2}, ` : "";
  post.address += post.city ? `${post.city} - ` : "";
  post.address += post.state ? `${post.state}, ` : "";
  post.address += post.country ? post.country : "";
  post.whatsApp = p.whatsApp ? `https://wa.me/${clearPhone(p.whatsApp)}` : "";
  //post.address = `${post.street}, ${post.street2}, ${post.city} - ${post.state}, ${post.country}`;
};

const clearPhone = (phone: string) => {
  phone = phone.replace(/\D/g, "");
  if (phone.length < 11) {
    phone = `1${phone}`;
  }
  return `+${phone}`;
};

const fixUrl = (url: string) => {
  if (url.indexOf("http") === -1) {
    url = `//${url}`;
  }
  return url;
};

onBeforeMount(async () => {
  fetchPost();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("h1", null, _toDisplayString(post.name), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "desc",
          innerHTML: post.description
        }, null, 8, _hoisted_3),
        (post.address)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", null, _toDisplayString(post.address), 1)
            ]))
          : _createCommentVNode("", true),
        (post.phone)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  href: 'tel:' + clearPhone(post.phone),
                  target: "_blank"
                }, _toDisplayString(post.phone), 9, _hoisted_8)
              ])
            ]))
          : _createCommentVNode("", true),
        (post.email)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  href: 'mailto:' + post.email,
                  target: "_blank"
                }, _toDisplayString(post.email), 9, _hoisted_11)
              ])
            ]))
          : _createCommentVNode("", true),
        (post.webSite)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  href: fixUrl(post.webSite),
                  target: "_blank"
                }, _toDisplayString(post.webSite), 9, _hoisted_14)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("ul", null, [
            (post.facebook)
              ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                  _createElementVNode("a", {
                    href: fixUrl(post.facebook),
                    target: "_blank"
                  }, _hoisted_19, 8, _hoisted_17)
                ]))
              : _createCommentVNode("", true),
            (post.instagram)
              ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                  _createElementVNode("a", {
                    href: fixUrl(post.instagram),
                    target: "_blank"
                  }, _hoisted_23, 8, _hoisted_21)
                ]))
              : _createCommentVNode("", true),
            (post.whatsApp)
              ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                  _createElementVNode("a", {
                    href: post.whatsApp,
                    target: "_blank"
                  }, _hoisted_27, 8, _hoisted_25)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("img", {
          src: post.image
        }, null, 8, _hoisted_29)
      ])
    ])
  ]))
}
}

})